import Api from "../../utils/api";
import Endpoints from "../../core/config/Endpoints";

export class DashboardService {
    async cardStats() {
        const token = localStorage.getItem("token");
        if (!token) {
            return null;
        }
        const response = await Api.get(Endpoints.dashboardCardStats, {
            "Content-Type": "application/json",
            Authorization: token,
        });

        return response ?? null;
    }

    async cardSalesByType(filter) {
        const token = localStorage.getItem("token");
        if (!token) {
            return null;
        }
        const response = await Api.get(Endpoints.dashboardCardSalesByType, {
            "Content-Type": "application/json",
            Authorization: token,
        }, {...filter});

        return response ?? null;
    }

    async ordersByStatus(filter) {
        const token = localStorage.getItem("token");
        if (!token) {
            return null;
        }
        const response = await Api.get(Endpoints.dashboardOrdersByStatus, {
            "Content-Type": "application/json",
            Authorization: token,
        }, {...filter});

        return response ?? null;
    }

    async cardSales(filter) {
        const token = localStorage.getItem("token");
        if (!token) {
            return null;
        }
        const response = await Api.get(Endpoints.dashboardCardSales, {
            "Content-Type": "application/json",
            Authorization: token,
        }, {...filter});

        return response ?? null;
    }

    async cardSalesType(filter) {
        const token = localStorage.getItem("token");
        if (!token) {
            return null;
        }
        const response = await Api.get(Endpoints.dashboardCardSalesType, {
            "Content-Type": "application/json",
            Authorization: token,
        }, {...filter});

        return response ?? null;
    }
}